"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Header = exports.Footer = exports.Fixed = exports.Content = void 0;
var _react = _interopRequireDefault(require("react"));
var _tabModule = _interopRequireDefault(require("./tab.module.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Tab = function Tab(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _tabModule["default"].tab,
    style: props.style,
    "data-testid": "tab"
  }, props.children);
};
var Header = exports.Header = function Header(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _tabModule["default"].header,
    "data-testid": "header"
  }, props.children);
};
var Content = exports.Content = function Content(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _tabModule["default"].content,
    "data-testid": "content"
  }, props.children);
};
var Footer = exports.Footer = function Footer(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _tabModule["default"].footer,
    "data-testid": "footer"
  }, props.children);
};
var Fixed = exports.Fixed = function Fixed(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _tabModule["default"].fixed,
    "data-testid": "fixed"
  }, props.children);
};
var _default = exports["default"] = Tab;